import React, { useState } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import { useNavigate } from "react-router-dom";

// Imports originales
import image1 from "../assets/slider1.webp"
import image2 from "../assets/slider2.webp"
import image3 from "../assets/slider3.webp"
import image4 from "../assets/slider4.webp"
import image5 from "../assets/slider5.webp"
import image6 from "../assets/slider6.webp"
import image2016 from "../assets/2016.webp"
import image2017 from "../assets/2017.webp"
import image2018 from "../assets/2018.webp"
import image2019 from "../assets/2019.webp"
import image2020 from "../assets/2020.webp"
import image2021 from "../assets/2021.jpg"
import image2022 from "../assets/2022.webp"
import image2023 from "../assets/2023.jpg"
import image2024 from "../assets/2024.jpg"
import Banner from "../assets/banner0.webp"
import logo1 from "../assets/logo1.jpg"

// Imports de miniaturas para la línea de tiempo
//2016
import d3slider7 from "../assets/d3slider7.webp";
import d3slider6 from "../assets/d3slider6.webp";
import d3slider4 from "../assets/d3slider4.webp";

import dona2slider5 from "../assets/dona2slider5.webp";
import dona2slider11 from "../assets/dona2slider11.webp";
import dona2slider6 from "../assets/dona2slider6.webp";
import dona2slider9 from "../assets/dona2slider9.webp";
import dona2slider8 from "../assets/dona2slider8.webp";
import dona2slider10 from "../assets/dona2slider10.webp";

import premioSlider2 from "../assets/premioSlider2.webp";
import premioSlider4 from "../assets/premioSlider4.webp";
import premioSlider6 from "../assets/premioSlider6.webp";
import premioSlider8 from "../assets/premioSlider8.webp";
import premioSlider11 from "../assets/premioSlider11.webp";

import slider6 from "../assets/slider6.webp";
import navi7slider1 from "../assets/navi7slider1.webp";
import navi7slider2 from "../assets/navi7slider2.webp";
import navi7slider3 from "../assets/navi7slider3.webp";
import navi7slider4 from "../assets/navi7slider4.webp";
import navi7slider5 from "../assets/navi7slider5.webp";
import navi7slider6 from "../assets/navi7slider6.webp";
import navi7slider7 from "../assets/navi7slider7.webp";
import navi7slider8 from "../assets/navi7slider8.webp";
import navi7slider9 from "../assets/navi7slider9.webp";
import navi7slider10 from "../assets/navi7slider10.webp";
import navi7slider11 from "../assets/navi7slider11.webp";

//2017
import dona2slider1 from "../assets/dona2slider1.webp";
import dona2slider2 from "../assets/dona2slider2.webp";
import dona2slider3 from "../assets/dona2slider3.webp";
import dona2slider4 from "../assets/dona2slider4.webp";
import dona2slider7 from "../assets/dona2slider7.webp";

import premioSlider5 from "../assets/premioSlider5.webp";
import premioSlider13 from "../assets/premioSlider13.webp";
import premioSlider10 from "../assets/premioSlider10.webp";

import navi6slider1 from "../assets/navi6slider1.webp";
import navi6slider2 from "../assets/navi6slider2.webp";
import navi6slider3 from "../assets/navi6slider3.webp";
import navi6slider4 from "../assets/navi6slider4.webp";

//2018
import dona1slider1 from "../assets/dona1slider1.webp";
import dona1slider2 from "../assets/dona1slider2.webp";
import dona1slider3 from "../assets/dona1slider3.webp";
import dona1slider4 from "../assets/dona1slider4.webp";

import d4slider1 from "../assets/d4slider1.webp";
import d4slider2 from "../assets/d4slider2.webp";
import d4slider3 from "../assets/d4slider3.webp";
import d4slider4 from "../assets/d4slider4.webp";


import slider201815 from "../assets/slider201815.webp";
import slider201816 from "../assets/slider201816.webp";
import slider20189 from "../assets/slider20189.webp";
import slider20187 from "../assets/slider20187.webp";
import slider20188 from "../assets/slider20188.webp";
import slider20185 from "../assets/slider20185.webp";
import slider20186 from "../assets/slider20186.webp";
import slider20182 from "../assets/slider20182.webp";
import slider20181 from "../assets/slider20181.webp";

import navi5slider1 from "../assets/navi5slider1.webp";
import navi5slider2 from "../assets/navi5slider2.webp";
import navi5slider3 from "../assets/navi5slider3.webp";
import navi5slider4 from "../assets/navi5slider4.webp";
import navi5slider5 from "../assets/navi5slider5.webp";
import navi5slider6 from "../assets/navi5slider6.webp";
import navi5slider7 from "../assets/navi5slider7.webp";

//2019
import dona4slider1 from "../assets/dona4slider1.webp";
import dona4slider2 from "../assets/dona4slider2.webp";
import dona4slider3 from "../assets/dona4slider3.webp";
import dona4slider4 from "../assets/dona4slider4.webp";
import dona4slider5 from "../assets/dona4slider5.webp";

import diseño from "../assets/diseño.png";

import slider20191 from "../assets/slider20191.webp";
import slider20192 from "../assets/slider20192.webp";
import slider20193 from "../assets/slider20193.webp";
import slider20194 from "../assets/slider20194.webp";
import slider20195 from "../assets/slider20195.webp";
import slider20196 from "../assets/slider20196.webp";
import slider20197 from "../assets/slider20197.webp";

import navi4slider1 from "../assets/navi4slider1.webp";
import navi4slider2 from "../assets/navi4slider2.webp";
import navi4slider3 from "../assets/navi4slider3.webp";
import navi4slider4 from "../assets/navi4slider4.webp";
import navi4slider5 from "../assets/navi4slider5.webp";
import navi4slider6 from "../assets/navi4slider6.webp";
import navi4slider7 from "../assets/navi4slider7.webp";

//2020
import donacionMercados from "../assets/donacionMercado.png";

import navi3slider1 from "../assets/navi3slider1.webp";
import navi3slider2 from "../assets/navi3slider2.webp";
import navi3slider3 from "../assets/navi3slider3.webp";

//2021
import dona5slider1 from "../assets/dona5slider1.webp";

import slider20211 from "../assets/slider20211.webp";
import slider20212 from "../assets/slider20212.webp";
import slider20213 from "../assets/slider20213.webp";
import slider20214 from "../assets/slider20214.webp";
import slider20215 from "../assets/slider20215.webp";
import slider20216 from "../assets/slider20216.webp";
import slider20217 from "../assets/slider20217.webp";

import navi2slider1 from "../assets/navi2slider1.webp";
import navi2slider2 from "../assets/navi2slider2.webp";

//2022
import proyectoAmbiental from "../assets/proyectoAmbiental.png";

import dona6slider1 from "../assets/dona6slider1.webp";
import dona6slider2 from "../assets/dona6slider2.webp";
import dona6slider3 from "../assets/dona6slider3.webp";
import dona6slider4 from "../assets/dona6slider4.webp";
import dona6slider5 from "../assets/dona6slider5.webp";
import dona6slider6 from "../assets/dona6slider6.webp";

import slider20221 from "../assets/slider20221.webp";
import slider20222 from "../assets/slider20222.webp";
import slider20223 from "../assets/slider20223.webp";

import dona7slider1 from "../assets/dona7slider1.webp";

import navi1slider1 from "../assets/navi1slider1.webp";
import navi1slider2 from "../assets/navi1slider2.webp";
import navi1slider3 from "../assets/navi1slider3.webp";
import navi1slider4 from "../assets/navi1slider4.webp";
import navi1slider5 from "../assets/navi1slider5.webp";

//2023
import dona8slider1 from "../assets/dona8slider1.webp";
import dona8slider2 from "../assets/dona8slider2.webp";
import dona8slider3 from "../assets/dona8slider3.webp";
import dona8slider4 from "../assets/dona8slider4.webp";
import dona8slider5 from "../assets/dona8slider5.webp";
import dona8slider6 from "../assets/dona8slider6.webp";

import dona9slider1 from "../assets/dona9slider1.webp";

import slider20231 from "../assets/slider20231.webp";
import slider20232 from "../assets/slider20232.webp";
import slider20233 from "../assets/slider20233.webp";
import slider20234 from "../assets/slider20234.webp";
import slider20235 from "../assets/slider20235.webp";
import slider20236 from "../assets/slider20236.webp";
import slider20237 from "../assets/slider20237.webp";
import slider20238 from "../assets/slider20238.webp";
import slider20239 from "../assets/slider20239.webp";
import slider202310 from "../assets/slider202310.webp";
import slider202311 from "../assets/slider202311.webp";
import slider202312 from "../assets/slider202312.webp";
import slider202313 from "../assets/slider202313.webp";
import slider202314 from "../assets/slider202314.webp";

import navi8slider1 from "../assets/navi8slider1.webp";
import navi8slider2 from "../assets/navi8slider2.webp";
import navi8slider3 from "../assets/navi8slider3.webp";
import navi8slider4 from "../assets/navi8slider4.webp";
import navi8slider5 from "../assets/navi8slider5.webp";
import navi8slider6 from "../assets/navi8slider6.webp";
import navi8slider7 from "../assets/navi8slider7.webp";
import navi8slider8 from "../assets/navi8slider8.webp";
import navi8slider9 from "../assets/navi8slider9.webp";
import navi8slider10 from "../assets/navi8slider10.webp";
import navi8slider11 from "../assets/navi8slider11.webp";
import navi8slider12 from "../assets/navi8slider12.webp";
import navi8slider13 from "../assets/navi8slider13.webp";
import navi8slider14 from "../assets/navi8slider14.webp";
import navi8slider15 from "../assets/navi8slider15.webp";
import navi8slider16 from "../assets/navi8slider16.webp";

//2024
import dona10slider1 from "../assets/dona10slider1.webp";
import dona10slider2 from "../assets/dona10slider2.webp";
import dona10slider3 from "../assets/dona10slider3.webp";
import dona10slider4 from "../assets/dona10slider4.webp";
import dona10slider5 from "../assets/dona10slider5.webp";
import dona10slider6 from "../assets/dona10slider6.webp";
import dona10slider7 from "../assets/dona10slider7.webp";

import slider20241 from "../assets/slider20241.webp";
import slider20242 from "../assets/slider20242.webp";
import slider20243 from "../assets/slider20243.webp";
import slider20244 from "../assets/slider20244.webp";

import navi9slider1 from "../assets/navi9slider1.webp";
import navi9slider2 from "../assets/navi9slider2.webp";
import navi9slider3 from "../assets/navi9slider3.webp";
import navi9slider4 from "../assets/navi9slider4.webp";
import navi9slider5 from "../assets/navi9slider5.webp";
import navi9slider6 from "../assets/navi9slider6.webp";
import navi9slider7 from "../assets/navi9slider7.webp";
import navi9slider8 from "../assets/navi9slider8.webp";
import navi9slider9 from "../assets/navi9slider9.webp";
import navi9slider10 from "../assets/navi9slider10.webp";
import navi9slider11 from "../assets/navi9slider11.webp";
import navi9slider12 from "../assets/navi9slider12.webp";
import navi9slider13 from "../assets/navi9slider13.webp";
import navi9slider14 from "../assets/navi9slider14.webp";
import navi9slider15 from "../assets/navi9slider15.webp";
import navi9slider16 from "../assets/navi9slider16.webp";
import navi9slider17 from "../assets/navi9slider17.webp";
import navi9slider18 from "../assets/navi9slider18.webp";
import navi9slider19 from "../assets/navi9slider19.webp";
//2025
import dona11slider1 from "../assets/dona11slider1.webp";
import dona11slider2 from "../assets/dona11slider2.webp";
import dona11slider3 from "../assets/dona11slider3.webp";
import dona11slider4 from "../assets/dona11slider4.webp";
import dona11slider5 from "../assets/dona11slider5.webp";

import slider20251 from "../assets/slider20251.webp";
import slider20252 from "../assets/slider20252.webp";
import slider20253 from "../assets/slider20253.webp";
import slider20254 from "../assets/slider20254.webp";

import navi10slider1 from "../assets/navi10slider1.webp";
import navi10slider2 from "../assets/navi10slider2.webp";
import navi10slider3 from "../assets/navi10slider3.webp";
import navi10slider4 from "../assets/navi10slider4.webp";

import Navbar from "./Navbar";
import Footer from "./Footer";
import ScrollToTop from "./ScrollToTop";
import { FaFacebookSquare, FaInstagram, FaTwitterSquare, FaYoutube, FaCalendarAlt, FaTimes, FaArrowRight } from 'react-icons/fa';

const Home = () => {
  let navigate = useNavigate();
  const [añoSeleccionado, setAñoSeleccionado] = useState("2025");
  const [eventoSeleccionado, setEventoSeleccionado] = useState(null);
  const scrollRef = React.useRef(null);

  React.useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({ left: 0, behavior: 'smooth' });
    }
  }, [añoSeleccionado]); // Se ejecuta cada vez que cambia el año

  const arrayAños = [
    {
      year: "2016",
      meses: [
        { title: "Creación de la Fundación", mes: "Junio 28", images: logo1, text: "Se eleva a escritura pública la creación de la Fundadocentes JDD con el auspicio de AsoBiffi y la Comunidad de los Hermanos Cristianos de La Salle." },
        { title: "Apertura 1ra Convocatoria Premio", mes: "Agosto 10", images: logo1, text: "Apertura de la convocatoria al Premio AsoBiffi Fundadocentes JDD a la Vida y Obra del Pedagogo de la Comunidad de los Hermanos de La Salle en su 1ra versión Colegio Biffi La Salle." },
        { title: "Reconocimiento Docente Luis Noriega", mes: "Octubre 08", images: [d3slider7, d3slider6, d3slider4], text: "Se resalta la labor del docente Luis Noriega por sus logros en los IV Juegos Nacionales LaSallistas 2016 realizados en el Colegio Biffi La Salle en sus 120 años de fundado." },
        { title: "Actividad Social en Sitionuevo", mes: "Octubre 23", images: [dona2slider5, dona2slider6, dona2slider11, dona2slider9, dona2slider8, dona2slider10], text: "Se realiza actividad social en el Centro Educativo Integral El Divino Niño que benefició a más de 70 familias pertenecientes a la comunidad de Sitionuevo mediante la donación de prendas de vestir." },
        { title: "Selección de Ganadores Premio JDD", mes: "Noviembre 01", images: logo1, text: "Reunión del jurado para la selección de los ganadores del Premio AsoBiffi Fundadocentes JDD a la Vida y Obra del Pedagogo de la Comunidad de los Hermanos de La Salle 1ra versión." },
        { title: "1ra Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Noviembre 18", images: [premioSlider2, premioSlider8, premioSlider4, premioSlider6, premioSlider11], text: "La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su primera edición, se realizó el 18 de Noviembre en las instalaciones del Colegio Biffi La Salle en la ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas a los docentes Eduardo Pulido y Jorge Moreno, ganadores del premio en primer y segundo lugar respectivamente. A su vez, se hizo entrega de una mención de honor a la psicóloga Claudia Rodríguez por su participación." },
        { title: "Regalos Navideños ", mes: "Diciembre 18", images: [slider6, navi7slider1, navi7slider2, navi7slider3, navi7slider4, navi7slider5, navi7slider6, navi7slider7, navi7slider8, navi7slider9, navi7slider10, navi7slider11], text: "En la Institución Educativa Distrital N° 176 se hace entrega de regalos navideños a los niños pertenecientes a la comunidad del Corregimiento de Juan Mina, Atlántico. Asi mismo se realizan donaciones a más de 30 niños del Barrio La Manga." }
      ]
    },
    {
      year: "2017",
      meses: [
        { title: "Apertura 2da Convocatoria Premio", mes: "Junio 23", images: logo1, text: "Apertura de la convocatoria al Premio Vida y Obra del Pedagogo de la Comunidad de los Hermanos de La Salle en su segunda edición Colegio Biffi La Salle e Instituto La Salle Barranquilla." },
        { title: "Proceso de Entrevistas Docentes", mes: "Agosto 20", images: logo1, text: "Inicia proceso de entrevistas y verificación de evidencias con los docentes participantes del Premio Vida y Obra del Pedagogo en su 2da Versión." },
        { title: "Selección de Ganadores 2da Versión", mes: "Noviembre 21", images: logo1, text: "Reunión del jurado para la selección de los ganadores al Premio Vida y Obra del Pedagogo 2da Versión." },
        { title: "Donaciones en Sitio Nuevo", mes: "Diciembre 01", images: [dona2slider1, dona2slider2, dona2slider3, dona2slider4, dona2slider7], text: "Se realiza actividad social que beneficia a la comunidad de Sitio Nuevo, Magdalena con la entrega de prendas de vestir y útiles escolares para la Institución Educativa El Divino Niño." },
        { title: "2da Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Diciembre 05", images: [premioSlider5, premioSlider13, premioSlider10], text: "La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su segunda edición, se realizó el 05 de Diciembre en el club ABC en ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas a los docentes Andreana Heredia y Naileth Caballero ganadores del premio en primer lugar, y al docente Manuel Rios ganador en segundo lugar." },
        { title: "Navidad en Barrio La Manga", mes: "Diciembre 12", images: [navi6slider1, navi6slider2, navi6slider3, navi6slider4], text: "Se realiza entrega de regalos navideños a mas de 30 niños pertenecientes a la comunidad del barrio La Manga ubicado en Barranquilla, Atlantico." }
      ]
    },
    {
      year: "2018",
      meses: [
        { title: "Entrega de Computadores Portátiles", mes: "Enero 25", images: [dona1slider1, dona1slider2, dona1slider3, dona1slider4], text: "En el Centro Educativo El Divino Niño ubicado en el municipio de Sitio Nuevo, Magdalena se realiza una donación de equipos de computación para el acondicionamiento de una sala de informática." },
        { title: "Exaltación Docente Manuel Álvarez", mes: "Junio 01", images: [d4slider1, d4slider2, d4slider3, d4slider4], text: "En el municipio Sucre perteneciente al departamento de Sucre se hace entrega en presencia del Secretario de Educación del municipio Jose Miguel Sánchez de una placa de reconocimiento al docente Isidro Manuel Álvarez Jaraba por su vocación de docente en la conservación y divulgación de los orígenes de la obra literaria del Premio Nobel Gabriel García Márquez." },
        { title: "Apertura 3era Convocatoria Premio", mes: "Julio 27", images: logo1, text: "Apertura de la 3era Convocatoria Premio Vida y Obra del Pedagogo con participación del Colegio Biffi La Salle, Instituto La Salle Barranquilla y Colegio La Salle Montería." },
        { title: "Definición Proyecto CEAS", mes: "Septiembre 10", images: logo1, text: "Definición del Proyecto CEAS San Juan de Dios – Centro Educativo y Atención de Salud Básica en Sitio Nuevo, Magdalena." },
        { title: "3era Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Octubre 30", images: [slider201815, slider201816, slider20189, slider20187, slider20188, slider20185, slider20186, slider20182, slider20181], text: "La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su tercera edición, se realizó el 30 de Octubre en el club ABC en ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas al docente Luis Hoyos vinculado al Colegio La Salle Montería y ganador del premio en primer lugar, y a la docente Maria Eugenia Arias del Instituto La Salle Barranquilla ganadora en segundo lugar." },
        { title: "Navidad Rural en Sitio Nuevo", mes: "Diciembre 21", images: [navi5slider1, navi5slider2, navi5slider3, navi5slider4, navi5slider5, navi5slider6, navi5slider7], text: "Se realiza un compartir navideño con el apoyo de más de 10 voluntarios en zona rural de Sitio Nuevo, Magdalena y se hace entrega de más de 200 regalos a niños en condición de vulnerabilidad." }
      ]
    },
    {
      year: "2019",
      meses: [
        { title: "Charla sobre Gabriel García Márquez", mes: "Abril 11", images: [dona4slider1, dona4slider2, dona4slider3, dona4slider4, dona4slider5], text: "En la charla de García Marquez en La Mojana, se hace un recuento de la presencia de esta región y su historia en la obra del Premio Nobel. Fue realizada por el docente Manuel Isidro Alvarez, autor del libro sobre las aguas y gran conocedor de la obra de Gabriel García Marquez." },
        { title: "Diseño del Proyecto CEAS", mes: "Mayo 03", images: diseño, text: "Diseño del Colegio y Centro de atención básica en salud proyecto CEAS San Juan de Dios, ubicado en Sitio Nuevo, Magdalena." },
        { title: "4ta Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Octubre 4", images: [slider20191, slider20192, slider20193, slider20194, slider20195, slider20196, slider20197], text: "La ceremonia de reconocimiento y premiación a los docentes ganadores del Premio a la Vida y Obra del pedagogo en su cuarta edición, se realizó el 24 de Octubre en el club ABC en ciudad de Barranquilla, Colombia. Durante la misma se hizo entrega de placas al docente Fausto Chatella y a la docente Carmen Curcio. Así mismo se exalto a la Congregación de los Hermanos de la Escuelas Cristianas de La Salle y al Instituto Hijas de Maria Auxiliadora." },
        { title: "Jornadas Navideñas 2019", mes: "Diciembre 20", images: [navi4slider1, navi4slider2, navi4slider3, navi4slider4, navi4slider5, navi4slider6, navi4slider7], text: "Se realiza un compartir navideño con el apoyo de más de 20 voluntarios en zona rural de Sitio Nuevo, Magdalena y se hace entrega de más de 300 regalos a niños en condición de vulnerabilidad." }
      ]
    },
    {
      year: "2020",
      meses: [
        { title: "Redefinición por Pandemia", mes: "Marzo", images: logo1, text: "Por la pandemia del Covid 19 desde el mes de marzo de 2020 se redefinio la agenda de trabajo para el año 2020, reprogramando algunas actividades y desarrollando otras." },
        { title: "Entrega de mercados", mes: "Julio", images: donacionMercados, text: "Se entregaron mercados a familias en estado vulnerable afectadas por la pandemia Covid 19 en Sitionuevo, Magdalena." },
        { title: "Navidad en Tiempos de Pandemia", mes: "Diciembre", images: [navi3slider1, navi3slider2, navi3slider3], text: "Se entregaron mercados navideños y regalos a niñas y niños de los sectores rurales de Sitionuevo Magdalena, Tubará Atlántico y Barrio La Manga Barranquilla. Las entregas fueron de casa en casa guardando los protocolos de bioseguridad, incluye entrega de tapabocas a cada familia." }
      ]
    },
    {
      year: "2021",
      meses: [
        { title: "Donación de Útiles Escolares", mes: "Julio 24", images: dona5slider1, text: "Realizamos entrega de útiles escolares a la comunidad de Sitionuevo Magdalena, apoyando la labor liderada por el Alcalde de este municipio ribereño del departamento del Magdalena, con la ayuda de Efraín Sánchez Jr, Juan De la Cruz y Rodolfo Fonseca." },
        { title: "5ta Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Octubre 27", images: [slider20211, slider20212, slider20213, slider20214, slider20215, slider20216, slider20217], text: "La 5ª. Versión del Premio Vida y Obra del Pedagogo, incluyó profesores nominados en el año 2020, que no fueron premiados en ese año por la pandemia COVID 19 que nos obligó a cancelar esta actividad. El día 27 de octubre de 2021 se llevó a cabo en el Club ABC de Barranquilla la entrega de reconocimientos. Docentes Eméritos: JESUS MARIA ACEVEDO PALMA, JUSTO VARGAS LASCARRO, ADONAY JARAMILLO GARRIDO. Docentes Resaltados: ALVARO BUSTILLO SOLANO, SERGIO NIÑO ARAQUE." },
        { title: "Presentación Internacional CEAS", mes: "Noviembre 15", images: diseño, text: "Presentación a ONGs internacionales del proyecto agroindustrial CEAS (Centro Educativo y Asistencia de Salud) Sitionuevo Magdalena." },
        { title: "Actividades Navideñas Rurales", mes: "Diciembre 21 y 22", images: [navi2slider1, navi2slider2], text: "Entrega de regalos navideños y actividades culturales con niños y familias de los sectores rurales de Sitionuevo, el Torno Departamento del Magdalena, en Tubara sector Mocana del Departamento del Atlántico y Barrio la Manga de Barranquilla." }
      ]
    },
    {
      year: "2022",
      meses: [
        { title: "Reconocimiento al Docente Everth Ortega", mes: "Abril", images: proyectoAmbiental, text: "Reconocimiento y acompañamiento al Docente Everth de Jesús Ortega Vizcaino. Proyecto ambiental Nueva Venecia. Extracción de botellas y plástico de la Ciénaga Grande del Magdalena. Se resalta la labor ambiental, donde se genera en la comunidad conciencia y acciones para limpiar la ciénaga grande del Magdalena, de la contaminación de plásticos y botellas, las cuales están deteriorando de manera dramática la vida y ecosistema de la ciénaga grande del Magdalena." },
        { title: "Jornada de Salud en Tubará", mes: "Agosto", images: [dona6slider1, dona6slider2, dona6slider3, dona6slider4, dona6slider5, dona6slider6], text: "Jornada de Salud Infantil en el corregimiento El Corral de San Luis Municipio de Tubara Atlántico desarrollada el 27 de agosto de 2022, donde con éxito y al apoyo de Procaps Coomonomeros, otras personas benefactores y funcionarios de Sura Monomeros y Fundadocente JDD quienes a titulo personal se unieron a la campaña de salud donde se atendieron en medicina infantil mas de 90 niños, en psicología infantil y de familia mas de 15 niños, y 20 adultos en medina general. Labor cumplida con éxito de la mano de un gran grupo de personas de la comunidad y de profesionales de la salud." },
        { title: "6ta Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Octubre", images: [slider20221, slider20222, slider20223], text: "Entrega de reconocimiento docentes en la 6a entrega del Premio Vida y Obra del Pedagogo. Docentes Eméritos: JOSÉ MANUEL PEREZ SARMIENTO, MANUEL VARELA BARRAZA. Docentes Resaltados: DIANA FISCHER PEÑA, REYMES ROBERTO ROCHA GOMEZ, EDGAR ASICLO HEREDIA REYES." },
        { title: "Apoyo a Vendedores Ambulantes", mes: "Diciembre", images: dona7slider1, text: "Charla y apoyo a vendedores ambulantes con chalecos de trabajo, actividad desarrollada en el barrio Don Jaca Santa Marta." },
        { title: "Gran Entrega de Regalos Navideños", mes: "Diciembre 21", images: [navi1slider1, navi1slider2, navi1slider3, navi1slider4, navi1slider5], text: "Entrega de 417 regalos de navidad a niños del Barrio La Manga en Barranquilla, Sitio Nuevo y Nueva Venecia Departamento del Magdalena, Corral de San Luis Tubará y Repelón Departamento del Atlántico." }
      ]
    },
    {
      year: "2023",
      meses: [
        { title: "Útiles Escolares en Sitionuevo", mes: "Febrero 25", images: [dona8slider1, dona8slider2, dona8slider3, dona8slider4, dona8slider5, dona8slider6], text: "El 25 de febrero de 2023 se efectuo jornada de entrega de utililes escolares a niños del municipio de Stionuevo y Sector de la Puente en el Departameto del Magadalena." },
        { title: "Donación de Computadora", mes: "Agosto 05", images: dona9slider1, text: "Se entrega computadora a estudiantes del colegio público de Sitionuevo Magdalena." },
        { title: "7ma Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Octubre 25", images: [slider20231, slider20232, slider20233, slider20234, slider20235, slider20236, slider20237, slider20238, slider20239, slider202310, slider202311, slider202312, slider202313, slider202314], text: "Fundación FUNDA DOCENTE JDD, celebró la septima entrega del premio vida y obra del Pedagogo. Docentes Eméritos: NESTOR ALBOR SARMIENTO, ROBINSON PEÑA VALENCIA. Docentes Resaltados: NUBIA HUERTAS CAMACHO, MARGARITA SABALZA MAESTRE." },
        { title: "Navidad en La Manga y Tubará", mes: "Diciembre 21, 22, 23", images: [navi8slider1, navi8slider2, navi8slider3, navi8slider4, navi8slider5, navi8slider6, navi8slider7, navi8slider8, navi8slider9, navi8slider10, navi8slider11, navi8slider12, navi8slider13, navi8slider14, navi8slider15, navi8slider16], text: "Fueron mas de 412 regalos entregados en Barrio La Manga Barranquilla, Corral de San luis Tubara Atlantico, La Puente Magdalena, Sitionuevo Magdalena, Barrio Siete de Agosto Barranquilla, Pital de Megua Baranoa Atlantico ,Sabanalarga Atlántico." }
      ]
    },
    {
      year: "2024",
      meses: [
        { title: "Jornada Educativa La Sierrita", mes: "Marzo 23", images: [dona10slider1, dona10slider2, dona10slider3, dona10slider4, dona10slider5, dona10slider6, dona10slider7], text: "El día sábado 23 de Marzo de 2024 se desarrolló la jornada educativa en la Biblioteca el Oasis del Barrio La Sierrita de Barranquilla donde a 38 niños y niñas se les acompañó en sus jornadas de formación, programadas por su directora Nubia Huertas y su equipo de apoyo, así mismo se entregaron útiles escolares y elementos educativos para apoyar el proceso sobresaliente que se está realizando en beneficio de muchos niños de la comunidad del Barrio La Sierrita." },
        { title: "8va Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Noviembre 27", images: [slider20241, slider20242, slider20243, slider20244], text: "En la escuela de Policía Antonio Nariño de Barranquilla se realizo la 8ª versión del Premio Vida y Obra del Pedagogo 2024. Docentes Eméritos: RDO. HNO. EDUARDO BOTERO GALLEGO, EDGARDO TOBIAS CLAVIJO MUÑOZ. Docentes Resaltados: HECTOR A. IRIARTE MARTINEZ, INT. RODOLFO A. CONEO MARTINEZ." },
        { title: "Jornadas Navideñas 2024", mes: "Diciembre 21, 22 y 23", images: [navi9slider1, navi9slider2, navi9slider3, navi9slider4, navi9slider5, navi9slider6, navi9slider7, navi9slider8, navi9slider9, navi9slider10, navi9slider11, navi9slider12, navi9slider13, navi9slider14, navi9slider15, navi9slider16, navi9slider17, navi9slider18, navi9slider19], text: "Los dias 21, 22 y 23 de diciembre se cumplieron las jornadas navideñas del año 2024, con el apoyo de varios benefactores y amigos se logró dar alegría a más de 220 niños en el barrios 20 de Julio de Barranquilla y los municipios de Sitio Nuevo Magdalena, Tubará y corregimiento San Luis Tubara en el Departamento del Atlántico" }
      ]
    },
    {
      year: "2025",
      meses: [
        { title: "Encuentro por el Bienestar Infantil", mes: "Noviembre 16", images: [dona11slider1, dona11slider2, dona11slider3, dona11slider4, dona11slider5], text: "Labor con niños creando espacios de cuidado y atención a niños de Sitionuevo Magdalena." },
        { title: "9na Ceremonia del Premio Vida y Obra del Pedagogo", mes: "Noviembre 19", images: [slider20251, slider20252, slider20253, slider20254], text: "Se realizo la 9ª versión del Premio Vida y Obra del Pedagogo 2025 con una emotiva ceremonia. Docentes Eméritos: ROBERTO GARCÍA PEÑA. Docentes Resaltados: JOSE LUIS PERTUZ CABEZA, ANTONIO A GARCÍA GARCÍA." },
        { title: "Jornada Navideña 2025", mes: "Diciembre 06 y 22", images: [navi10slider1, navi10slider2, navi10slider3, navi10slider4], text: "Los días 6 y 22 de diciembre, la Navidad llegó a los corazones de los niños en Magdalena y Atlántico. A través de la entrega de regalos, se tejieron lazos de alegría en Sitionuevo-Magdalena, Barrio La Sierrita Biblioteca el Oasis, Puerto Colombia, Tubara -Atlántico Corregimiento San Luis. Una jornada dedicada a celebrar la infancia y compartir la magia de la época." }
      ]
    }
  ];

  const datosFiltrados = arrayAños.find(a => a.year === añoSeleccionado)?.meses || [];

  return (
    <>
      <ScrollToTop />
      <Navbar />
      <div className="bg-gray-50">
        {/* BANNER (TAL CUAL TU ORIGINAL) */}
        <img className='animate-fade-in-down hidden md:flex absolute top-0 md:relative h-[80%] w-full md:h-full object-cover' src={Banner} alt='Banner' />
        <div className="animate-fade-in-down md:hidden relative font-sans">
          <img src={Banner} alt="Banner Image" className="absolute inset-0 w-full h-full object-cover" />
          <div className="min-h-[350px] relative h-full flex flex-col justify-center items-center text-center text-white p-6"></div>
        </div>

        {/* REDES SOCIALES ESTÉTICAS */}
        <div className='flex justify-end gap-3 my-1 pr-4'>
          {[
            { icon: <FaFacebookSquare size={22} />, link: "https://www.facebook.com/profile.php?id=61553758356775", color: "hover:text-blue-600", bg: "hover:bg-blue-50" },
            { icon: <FaInstagram size={22} />, link: "https://www.instagram.com/fundadocentejdd/", color: "hover:text-pink-600", bg: "hover:bg-pink-50" },
            { icon: <FaTwitterSquare size={22} />, link: "https://twitter.com/fundaDocenteJDD", color: "hover:text-sky-500", bg: "hover:bg-sky-50" },
            { icon: <FaYoutube size={22} />, link: "https://www.youtube.com/channel/UCv2MOMGmnU6RkHX9VOrxx0g", color: "hover:text-red-600", bg: "hover:bg-red-50" }
          ].map((red, index) => (
            <a
              key={index}
              target="_blank"
              rel="noreferrer"
              href={red.link}
              className={`flex items-center justify-center w-10 h-10 rounded-xl text-gray-500 bg-transparent transition-all duration-300 transform hover:-translate-y-1.5 hover:shadow-md ${red.color} ${red.bg}`}
            >
              {red.icon}
            </a>
          ))}
        </div>

        {/* SECCIÓN BALANCE SOCIAL (ÚNICA PARTE CAMBIADA) */}
        <div className='w-[95%] bg-white py-12 px-4 shadow-2xl rounded-3xl m-5 mx-auto -mt-0 relative z-10'>
          <h1 className="text-3xl md:text-5xl text-center font-bold mb-10 text-blue-900">Conoce nuestro Balance Social</h1>

          {/* AVISO DE SCROLL INTUITIVO */}
          <div className="flex justify-center items-center gap-2 xl:hidden animate-pulse">
            <span className="text-gray-700 text-[10px] uppercase tracking-[0.2em] font-semibold">
              ← Desliza para ver más años →
            </span>
          </div>


          {/* SELECTOR DE AÑOS CORREGIDO PARA 1374px */}
          <div className="relative group">
            <div className='flex overflow-x-auto pb-6 pt-4 scrollbar-hide snap-x'>
              <div className='flex md:mx-auto gap-6 px-12'>
                {["2025", "2024", "2023", "2022", "2021", "2020", "2019", "2018", "2017", "2016"].map((year) => (
                  <div
                    key={year}
                    onClick={() => setAñoSeleccionado(year)}
                    className={`hover:cursor-pointer min-w-[120px] shadow-xl flex flex-col p-4 rounded-xl transition-all duration-300 transform snap-center
            ${añoSeleccionado === year
                        ? 'bg-blue-800 scale-110 shadow-blue-200 z-10'
                        : 'bg-blue-500 hover:bg-blue-600'}`}
                  >
                    <p className='text-center text-2xl font-bold text-white'>{year}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>

          {/* LÍNEA DE TIEMPO HORIZONTAL SCROLLEABLE */}
          <div
            ref={scrollRef}
            className="relative w-full overflow-x-auto pb-12 pt-10 scrollbar-hide snap-x snap-mandatory"
          >
            {/* Contenedor de los eventos: 
      Cambiamos w-max por min-w-full y añadimos justify-center para equilibrar el espacio */}
            <div className="flex gap-8 px-10 md:px-20 min-w-full w-max justify-center relative">

              {/* Hilo conductor horizontal: 
        Ahora siempre ocupará al menos el 100% del ancho del viewport gracias al min-w-full del padre */}
              <div className="absolute top-[160px] md:top-[185px] left-0 right-0 h-1 bg-blue-100 rounded-full z-0"></div>

              {datosFiltrados.map((evento, index) => (
                <div
                  key={index}
                  className="relative flex flex-col items-center w-[280px] md:w-[350px] snap-center z-10 shrink-0" // shrink-0 evita que las cards se deformen al centrar
                >
                  {/* Punto en la línea de tiempo */}
                  <div className="z-30 absolute top-[140px] md:top-[165px] flex items-center justify-center w-10 h-10 bg-blue-800 rounded-full border-4 border-white shadow-lg">
                    <FaCalendarAlt className="text-white text-sm" />
                  </div>

                  {/* Contenedor del Evento (Card) */}
                  <div
                    onClick={() => setEventoSeleccionado(evento)}
                    className="bg-white p-6 rounded-[2rem] border border-gray-100 shadow-sm hover:shadow-2xl transition-all cursor-pointer group active:scale-95 flex flex-col items-center text-center w-full"
                  >
                    {/* Imagen Circular */}
                    {evento.images && (
                      <div className="mb-6 relative">
                        <div className="absolute inset-0 bg-blue-100 rounded-full scale-110 blur-md opacity-20 group-hover:opacity-40 transition-opacity"></div>
                        <div className="w-32 h-32 md:w-40 md:h-40 rounded-full overflow-hidden border-4 border-white shadow-xl bg-gray-50 relative z-10">
                          <img
                            src={Array.isArray(evento.images) ? evento.images[0] : evento.images}
                            alt={evento.title}
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                          />
                        </div>
                      </div>
                    )}

                    {/* Fecha */}
                    <span className="text-blue-600 font-black text-xs uppercase tracking-widest">
                      {evento.mes}
                    </span>

                    {/* Título */}
                    <h3 className="text-gray-800 text-base md:text-lg font-bold mt-2 leading-tight line-clamp-2 h-12">
                      {evento.title}
                    </h3>

                    <div className="mt-4 flex items-center text-blue-900 font-bold text-[10px] uppercase bg-blue-50 px-4 py-2 rounded-full group-hover:bg-blue-600 group-hover:text-white transition-colors">
                      Leer más <FaArrowRight className="ml-2 group-hover:translate-x-1 transition-transform" />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* AVISO DE SCROLL (Opcional pero recomendado) */}
          <div className="flex justify-center items-center gap-2 -mt-6 mb-10">
            <span className="text-gray-700 text-[10px] uppercase tracking-[0.2em] font-medium animate-pulse">
              ← Desliza los eventos →
            </span>
          </div>

        </div>

        {/* MODAL PARA DETALLE DEL EVENTO */}
        {eventoSeleccionado && (
          <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm">
            {/* Contenedor principal sin scroll global */}
            <div className="bg-white rounded-[2.5rem] w-full max-w-xl max-h-[90vh] flex flex-col relative shadow-2xl animate-in zoom-in duration-300 overflow-hidden">

              {/* SECCIÓN DE IMAGEN / GALERÍA (Fija arriba) */}
              <div className="w-full bg-gray-100 flex flex-col items-center justify-center min-h-[300px] shrink-0">
                {Array.isArray(eventoSeleccionado.images) ? (
                  <div className="flex overflow-x-auto snap-x snap-mandatory gap-2 p-4 w-full scrollbar-hide">
                    {eventoSeleccionado.images.map((img, idx) => (
                      <img
                        key={idx}
                        src={img}
                        alt={`Imagen ${idx}`}
                        className="snap-center max-h-[40vh] rounded-xl shadow-md object-contain inline-block"
                      />
                    ))}
                  </div>
                ) : (
                  <img
                    src={eventoSeleccionado.images}
                    alt="Hito"
                    className="max-w-full max-h-[45vh] object-contain p-4"
                  />
                )}
                {Array.isArray(eventoSeleccionado.images) && (
                  <span className="text-[10px] text-gray-400 pb-2 uppercase tracking-widest italic">
                    Desliza para ver más →
                  </span>
                )}
              </div>

              {/* ÁREA DE TEXTO SCROLLEABLE (Única parte que se mueve) */}
              <div className="p-8 overflow-y-auto flex-1 custom-scrollbar">
                <div className="flex items-center gap-2 text-blue-700 font-bold mb-2">
                  <FaCalendarAlt />
                  <span>{eventoSeleccionado.mes} / {añoSeleccionado}</span>
                </div>

                <h2 className="text-2xl font-bold text-gray-900 mb-4 leading-tight">
                  {eventoSeleccionado.title}
                </h2>

                <p className="text-gray-700 text-lg leading-relaxed font-light">
                  {eventoSeleccionado.text}
                </p>
              </div>

              {/* BOTÓN DE CIERRE (Fijo abajo) */}
              <div className="p-6 pt-0 shrink-0">
                <button
                  onClick={() => setEventoSeleccionado(null)}
                  className="w-full bg-blue-900 text-white py-4 rounded-2xl font-bold hover:bg-blue-800 transition-all active:scale-95 shadow-lg shadow-blue-100"
                >
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        )}

        {/* SECCIÓN PREMIOS - VERSIÓN MINIMALISTA (IMÁGENES COMPLETAS) */}
        <div className='w-[95%] max-w-[1300px] bg-white py-16 px-6 md:px-12 shadow-sm border border-gray-100 rounded-[2.5rem] my-20 mx-auto'>
          <div className='max-w-[1240px] mx-auto grid md:grid-cols-2 gap-12 items-center'>

            {/* Contenedor del Carrusel */}
            <div className="relative group rounded-3xl border overflow-hidden shadow-2xl bg-slate-50">
              <Carousel
                showStatus={false}
                showThumbs={false}
                infiniteLoop
                autoPlay
                interval={5000}
                className='overflow-hidden'
              >
                {[
                  { img: image1, txt: "Ceremonia de Premiación 3° Edición del Premio a la Vida y Obra del Pedagogo" },
                  { img: image2, txt: "Ceremonia de Premiación 2° Edición del Premio a la Vida y Obra del Pedagogo" },
                  { img: image3, txt: "Ceremonia de Premiación 5° Edición del Premio a la Vida y Obra del Pedagogo" },
                  { img: image4, txt: "Ceremonia de Premiación 1° Convocatoria del Premio a la Vida y Obra del Pedagogo" },
                  { img: image5, txt: "Docente Luis Noriega por su desempeño en los IV Juegos Nacionales LaSallistas" }
                ].map((item, index) => (
                  <div key={index} className="relative h-[350px] md:h-[450px] flex items-center justify-center">
                    {/* Cambiado a object-contain para no cortar caras */}
                    <img
                      src={item.img}
                      alt={`Slide ${index}`}
                      className="object-contain h-full w-full"
                    />
                    {/* Overlay sutil para el texto (ajustado para mayor legibilidad con contain) */}
                    <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 via-black/50 to-transparent p-8 text-left">
                      <p className="text-white text-sm md:text-base font-light opacity-95 drop-shadow-md">
                        {item.txt}
                      </p>
                    </div>
                  </div>
                ))}
              </Carousel>
            </div>

            {/* Contenedor de Texto */}
            <div className='flex flex-col justify-center space-y-6'>
              <div>
                <p className='text-blue-600 font-bold tracking-[0.2em] text-xs uppercase mb-2'>
                  FUNDADOCENTE JDD — ASOBIFFI
                </p>
                <h1 className='text-3xl md:text-5xl font-black text-slate-900 leading-tight'>
                  Ceremonia de Premiación <br />
                  <span className="text-blue-800">Premio Vida y Obra</span>
                </h1>
              </div>

              <p className="text-slate-600  text-lg leading-relaxed font-light">
                El Premio Vida y Obra del Pedagogo se crea con el objetivo de exaltar la labor de aquellos docentes que desde su área de desempeño,
                realizan actividades de significativo impacto en sus estudiantes, familias y entorno en el que se desenvuelve.
              </p>

              <p className="text-slate-600 leading-relaxed text-lg font-light">
                Mediante la entrega de este reconocimiento se busca promover una participación activa e integral de los docentes,
                favoreciendo así la construcción de una mejor sociedad.
              </p>

              <div className="pt-4">
                <button
                  onClick={() => { navigate("/convocatoria") }}
                  className='bg-blue-800 hover:bg-black text-white px-10 py-4 rounded-full font-semibold transition-all duration-300 transform hover:-translate-y-1 shadow-lg hover:shadow-blue-200/50'
                >
                  Convocatoria 2026
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Home;